const createRicosNodeExtension = (extension) => extension;
export {
  createRicosNodeExtension
};
//# sourceMappingURL=create-ricos-node-extension.js.map
